<lds-card padding="md">
  <div class="insight">

    <div class="insight__heading">
      <h3>{{ heading }}</h3>

      <div class="insight__trend" *ngIf="change">
        <lds-tag [appearance]="appearance" [label]="sign + ((change | percent:'1.0-2') || '')" ></lds-tag>
      </div>
    </div>

    <div class="insight__label">
      {{ text }}
    </div>

  </div>
</lds-card>
